export default function NumberInput({ 
    value, 
    placeholder, 
    min = 0, 
    max = 100, 
    step = 1,
    onChange = () => {}, 
    onBlur = () => {},
    subText = '',
    className = '',
    autoFocus = false,
    showArrows = true,
}) {
    return (
        <div className='w-full'>
            <input
                type="number"
                placeholder={placeholder}
                value={value || ''}
                min={min}
                max={max}
                step={step}
                className={`
                    w-full border border-gray-400 text-center focus:outline-none rounded-md
                    ${showArrows === true ? '[&::-webkit-inner-spin-button]:opacity-100 [&::-webkit-inner-spin-button]:block' : ''}
                    ${showArrows === false ? '[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none' : ''}
                    ${className}
                `}
                onChange={(e) => onChange(parseInt(e.target.value) || 0)}
                onBlur={onBlur}
                autoFocus={autoFocus}
            />

            {subText && 
                <div className='pt-1 pr-4 -mb-1 text-xs'>{subText}</div>
            }
        </div>
    )
}